module.exports = __webpack_public_path__ + "static/media/icon_for_subtitle.54baabd6.png";